const KEY = "ah_tracking";
const TTL = 30 * 24 * 3600 * 1000;

const EMPTY = {
  lead_source: "Website", utm_source: "", utm_medium: "", utm_campaign: "",
  utm_content: "", utm_term: "", landing_page: "", referrer_url: "",
};

function detectSource(utmSource, src, referrer) {
  const s = (src || utmSource || "").toLowerCase();
  if (s.includes("facebook") || s === "fb" || s.includes("meta")) return "Facebook";
  if (s.includes("instagram") || s === "ig") return "Instagram";
  if (s.includes("tiktok")) return "TikTok";
  if (s.includes("google")) return "Google";
  if (s.includes("qr")) return "QR Code";
  if (s.includes("ghl") || s.includes("gohighlevel")) return "GoHighLevel";
  if (s.includes("upfirst")) return "Upfirst AI";
  if (s.includes("referr")) return "Referral";
  if (s) return "Website";
  const r = (referrer || "").toLowerCase();
  if (r.includes("facebook.") || r.includes("fb.com")) return "Facebook";
  if (r.includes("instagram.")) return "Instagram";
  if (r.includes("tiktok.")) return "TikTok";
  if (r.includes("google.") || r.includes("bing.") || r.includes("duckduckgo.")) return "Organic Search";
  return "Website";
}

export function captureTracking(search, referrer) {
  try {
    const params = new URLSearchParams(search || "");
    const utm = {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
    };
    const src = params.get("src") || params.get("source") || "";
    const hasSignal = src || Object.values(utm).some(Boolean);
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    const expired = !existing || Date.now() - (existing.at || 0) > TTL;
    if (hasSignal || expired) {
      localStorage.setItem(KEY, JSON.stringify({
        ...utm,
        utm_campaign: utm.utm_campaign || src,
        src,
        lead_source: detectSource(utm.utm_source, src, referrer),
        landing_page: window.location.pathname + window.location.search,
        referrer_url: referrer || "",
        at: Date.now(),
      }));
    }
  } catch {}
}

export function getTracking() {
  try {
    const t = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!t) return { ...EMPTY };
    const { at, src, ...rest } = t;
    return { ...EMPTY, ...rest };
  } catch {
    return { ...EMPTY };
  }
}
